import React from "react";
import { HOME } from "@/constants/testIds";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export const FAQ = () => {
  const items = [
    {
      q: "How often is shipment data updated?",
      a: "Carrier and AIS feeds update continuously — most shipments refresh every few minutes, and milestone events propagate the moment they happen at origin or destination.",
    },
    {
      q: "Can I track multiple shipments at once?",
      a: "Yes. The Workspace shows every active shipment on a single map, list and timeline — filterable by carrier, supplier, milestone or destination port.",
    },
    {
      q: "Can I receive mobile notifications?",
      a: "Push notifications are available on iOS and Android, plus optional email digests and Slack/Teams webhooks for shared visibility.",
    },
    {
      q: "Can I track milestones, not just position?",
      a: "Yes — milestones from PO through delivery are first-class entities. Each has a timestamp, owner, attached documents and alert thresholds.",
    },
    {
      q: "Can I view shipment documents inside the Workspace?",
      a: "All shipment documents — bills of lading, certificates of origin, packing lists, insurance — attach directly to the shipment record and travel with it.",
    },
    {
      q: "How does Live Shipment Tracking™ connect with the rest of the Workspace?",
      a: "It plugs into RFQ™, CommodityBid™, FreightIQ™ and Inspection™. Every shipment carries its full upstream context — supplier, bid, freight booking and inspection — across one continuous workflow.",
    },
  ];

  return (
    <section
      id="faq"
      data-testid={HOME.faqSection}
      className="relative py-24 md:py-32"
    >
      <div className="container-narrow grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <div className="text-[11px] font-mono uppercase tracking-[0.18em] ink-soft mb-4">
            08 — FAQ
          </div>
          <h2 className="font-display text-4xl lg:text-5xl font-semibold ink leading-[1.05] text-balance">
            Common questions.
          </h2>
          <p className="mt-5 text-[14.5px] ink-soft max-w-sm">
            Need something specific? Talk to our solutions team — we&apos;ll walk you
            through the Workspace live, with your shipment data if you have it.
          </p>
        </div>

        <div className="lg:col-span-8">
          <Accordion type="single" collapsible className="space-y-2">
            {items.map((it, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={HOME.faqItem}
                className="rounded-2xl bg-white border border-ink-10 px-5 data-[state=open]:border-[hsla(217,71%,35%,0.35)]"
              >
                <AccordionTrigger className="text-left font-display text-[15.5px] font-semibold ink py-5 hover:no-underline">
                  {it.q}
                </AccordionTrigger>
                <AccordionContent className="text-[13.5px] ink-soft leading-relaxed pb-5">
                  {it.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};
